module.exports = __webpack_public_path__ + "img/key.b761b24b.png";